import Head from 'next/head';
import React from 'react';
import BaseLayout from 'layouts/BaseLayout';
import FriendsReferralContent from 'components/Invite/FriendsReferralContent';
import { COLOR_PURPLE_HOVER, COLOR_WHITE } from 'styles/variables/colors';
import useIsMobile from 'hooks/useIsMobile';

export default function FriendsReferralPage() {
  const isMobile = useIsMobile();

  return (
    <BaseLayout
      bgBrandColor={!isMobile ? COLOR_WHITE : COLOR_PURPLE_HOVER}
      headerWhite={true}
      typeBtn="buttonSecondary"
      hasPadding={false}
    >
      <Head>
        <title>Friends Referral - Mind The Graph</title>

        <meta
          key="og:image"
          name="og:image"
          property="og:image"
          content="/images/friend-referral.jpg"
        />
        <meta key="og:image:width" name="og:image:width" property="og:image:width" content="1200" />
        <meta
          key="og:image:height"
          name="og:image:height"
          property="og:image:height"
          content="627"
        />

        <meta
          key="og:description"
          property="og:description"
          content="Friends Referral - Mind The Graph"
        />
        <meta key="og:title" property="og:title" content="Friends Referral - Mind The Graph" />
      </Head>

      <FriendsReferralContent />
    </BaseLayout>
  );
}
